<template>
  <div
    v-if="hasNavigation"
    class="navigation overflow-hidden"
    :class="[
      $device.isMobile ? 'bg-white' : 'bg-secondary',
      {'left-navigation h-100': !$device.isMobile},
    ]"
  >
    <b-nav
      class="navigation-container align-items-center overflow-auto scroll-bar"
      justified
    >
      <b-nav-item
        v-for="tab of tabs"
        v-show="!tab.isHidden"
        :key="tab.key"
        class="cursor-pointer position-relative"
        :active="isActive(tab)"
        :class="[$device.isMobile ? 'text-12' : 'text-14']"
        @click="tabEvent(tab)"
      >
        <i class="text-32" :class="iconClass(tab)"></i>
        <p class="m-0">{{ tab.title }}</p>
        <div
          v-if="tab.key === 'verification' && hasVerificationNotification"
          class="notification bg-accent position-absolute"
        ></div>
      </b-nav-item>
    </b-nav>
    <ModalConfirm
      v-if="isEmptyMessageShow"
      :hide-cancel="true"
      @confirm="isEmptyMessageShow = false"
    >
      <template>
        {{ $t('目前没有学生') }}
        <br />
        {{ $t('请洽官方人员协助新增') }}
      </template>
    </ModalConfirm>
  </div>
</template>

<script>
import {getLocalData, saveLocalData} from '@/lib/base/localData';

export default {
  data() {
    return {
      isEmptyMessageShow: false,
    };
  },
  computed: {
    notifiable() {
      return (
        this.verificationData.state === 'ENABLE' ||
        this.verificationData.state === 'SCORE'
      );
    },
    verificationData() {
      return this.$store.getters['verification/verificationData'] || {};
    },
    hasVerificationNotification() {
      return this.$store.state.env.hasVerificationNotification;
    },
    isSidebarShow() {
      return this.$store.state.env.isSidebarShow;
    },
    isSidebarTeacherShow() {
      return this.$store.state.env.isSidebarTeacherShow;
    },
    hasNavigation() {
      return this.$route.meta?.hasNavigation;
    },
    active() {
      return this.$route.matched[0].name;
    },
    currentPlan() {
      return this.$store.getters['course/currentPlan'];
    },
    isTeacher() {
      return this.$store.getters['user/isTeacher'];
    },
    tabs() {
      return [
        {
          key: 'learningPage',
          icon: 'Home',
          title: this.$t('首页'),
          event: 'learningPage',
        },
        {
          key: 'ladder',
          icon: 'Stairs',
          title: this.$t('天梯'),
          event: 'ladder',
        },
        {
          key: 'verification',
          icon: 'Verification',
          title: this.$t('检定'),
          event: 'verificationList',
        },

        {
          key: 'management',
          icon: 'school',
          title: this.isTeacher ? this.$t('教师') : this.$t('学员'),
          event: this.isTeacher ? 'teacherManagement' : 'studentManagement',
        },
        {
          key: 'more',
          icon: 'Dots-circle-horizontal',
          title: this.$t('更多'),
          event: 'more',
        },
      ];
    },
  },
  methods: {
    iconClass(tab) {
      return `icon-${tab.icon}`;
    },
    async tabEvent(tab) {
      const event = tab.event;
      switch (event) {
        case 'more':
          if (this.$device.isMobile) {
            this.$router.push('/more');
          } else {
            this.$store.commit('env/setIsSidebarShow', !this.isSidebarShow);
            this.$store.commit('env/setIsSwitchCourseSheetShow', false);
          }
          break;
        case 'teacherManagement':
          if (this.$device.isMobile) {
            this.goStudentInformation();
          } else {
            this.$store.commit(
              'env/setIsSidebarTeacherShow',
              !this.isSidebarTeacherShow
            );
            this.$store.commit('env/setIsSwitchCourseSheetShow', false);
          }
          break;
        case 'verificationList':
          this.$store.commit('env/setHasVerificationNotification', false);
          const plansNotifiableStatus = {
            ...JSON.parse(getLocalData('plans-notifiable-status')),
          };
          plansNotifiableStatus[this.currentPlan.id] = this.notifiable;

          saveLocalData(
            'plans-notifiable-status',
            JSON.stringify(plansNotifiableStatus)
          );
          this.$router.push({name: 'verificationList'});
          break;
        default:
          if (this.$route.name !== tab.event) {
            this.$router.push({name: tab.event});
          }
          break;
      }
    },
    async goStudentInformation() {
      try {
        this.$store.commit('env/setIsLoading', true);
        this.$store.commit('env/setIsSidebarShow', false);
        await this.$store.dispatch('teacherManagement/getClasses');
        await this.$store.dispatch('teacherManagement/getStudentsByClass');
        const allStudents =
          this.$store.getters['teacherManagement/allStudents'];
        if (allStudents.length === 0) {
          this.$alert(this.$t('目前没有学生\n请洽官方人员协助新增'));
          return;
        }
        return this.$router.push({
          name: 'student-information',
          query: {
            active: 'learning-process',
          },
        });
      } catch (error) {
        console.error(error);
        this.$Message.error(this.$t('发生未知错误，再试一次'));
      } finally {
        this.$store.commit('env/setIsLoading', false);
      }
    },
    async getUnfinishedGame() {
      await this.$store.dispatch('aiGame/getUnfinishedGame');
      this.$store.commit('env/setIsLoading', false);
    },
    isActive(tab) {
      if (this.$route.name === 'no-lesson') {
        const type = this.$route.params.type;
        return type === tab.event;
      } else if (this.$device.isMobile) {
        if (this.$route.name === 'student-information') {
          return tab.event === 'teacherManagement';
        }

        return this.active === tab.event;
      } else {
        return (
          this.$route.path.includes(tab.event) || this.active === tab.event
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  .logo-container {
    padding: 8px 10px;
    margin: 0 0 8px;
    img {
      width: 100px;
    }
  }
  .navigation-container {
    box-shadow: inset 0 1px 0 0 $line-2;
    min-height: 62px;
  }
  .nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    min-height: 62px;
    color: #909399;
    border-radius: $rounded-md;
    &.active {
      color: $primary;
    }
  }

  .notification {
    width: 14px;
    height: 14px;
    top: 10px;
    right: 9px;
    border-radius: 50%;
  }

  &.left-navigation {
    position: relative;
    z-index: 1040;
    .navigation-container {
      box-shadow: none;
      flex-direction: column;
      flex-wrap: nowrap;
      max-width: 120px;
      height: calc(100% - 139px);
      padding: $spacing-s;
    }

    .nav-link {
      width: 84px;
      height: 80px;
      color: white;
      &:hover {
        background: rgba(255, 255, 255, 0.15);
      }
      &.active {
        background: rgba(255, 255, 255, 0.3);
      }
    }
    .nav-item {
      margin-bottom: 8px;
      max-height: 80px;
    }
  }
}
</style>
